<template>
  <div class="edit-view">
    <el-form class="my-form" ref="form" size="large" label-position="top" :hide-required-asterisk="false" :model="fromData" :inline-message="true">
      <el-form-item label="项目标题" prop="title">
        <el-input
          class="input-style has-color"
          v-model="fromData.title"
          placeholder="请输入项目名称"
          :disabled="projectDetailVisible"
        >
          <template slot="prefix">
            <ColorControl :dataset="fromData" @change="colorChange" :defaultText="fromData.title" :disabled="projectDetailVisible"></ColorControl>
          </template>
        </el-input>
      </el-form-item>

      <el-form-item label="分类" prop="project_list_id">
        <el-select v-model="fromData.project_list_id" placeholder="请选择业务线" :disabled="projectDetailVisible">
          <el-option v-show="item.active" v-for="item in projectFoderList" :key="item.project_list_id" :label="item.title" :value="item.project_list_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="项目描述" prop="content">
        <el-input :disabled="projectDetailVisible" type="textarea" size="small" :rows="8" placeholder="请输入项目描述" v-model="fromData.content"></el-input>
      </el-form-item>
      <el-form-item label="默认视图" prop="default_view">
        <el-radio-group v-model="fromData.default_view" @tab-click="handleClick" size="mini" :disabled="projectDetailVisible">
          <el-radio label="1">看板</el-radio>
          <el-radio label="2">列表</el-radio>
          <el-radio label="3">甘特图</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="关联产品项" prop="product_ids" :disabled="projectDetailVisible" v-if="dataset.project_depart_id === 1">
        <el-cascader :props="props" :options="options"  :disabled="projectDetailVisible || !isCeartor" :placeholder="projectDetailVisible || !isCeartor ? '暂无关联产品项' : '请选择'" v-model="fromData.product_ids" @expand-change="productChange"></el-cascader>
      </el-form-item>
    </el-form>
    <el-row v-if="!projectDetailVisible">
      <el-col :span="24">
        <wf-button size="small" type="primary" @click="save" :loading="loading" auto class="save-btn">保存设置</wf-button>
      </el-col>
    </el-row>
    <el-row class="tool-item" v-if="!projectDetailVisible">
      <div class="edit-title">冻结项目</div>
      <el-col :span="24" class="edit-conten">冻结该项目后，将暂停项目内的所有编辑功能。你可以重新激活将项目恢复正常。</el-col>
      <el-col :span="24" class="edit-btn">
        <wf-button @click="frozenProject" plain size="small" type="primary" auto>了解，冻结项目</wf-button>
      </el-col>
    </el-row>
    <el-row class="tool-item" :gutter="10" v-if="!projectDetailVisible">
      <div class="edit-title">归档项目</div>
      <el-col :span="24" class="edit-conten">归档项目后，将不再出现在项目工作台中。你可以重新激活将项目恢复正常。</el-col>
      <el-col :span="24" class="edit-btn">
        <wf-button @click="arcProject" plain size="small" type="primary" auto>了解，归档项目</wf-button>
      </el-col>
    </el-row>
    <el-row class="tool-item" v-if="dataset.delete_permissions">
      <div class="edit-title">删除项目</div>
      <el-col :span="24" class="edit-conten">删除项目后，所有内容将被抹去，请谨慎操作。</el-col>
      <el-col :span="24" class="edit-btn">
        <wf-button @click="delProject" plain size="small" type="danger" auto>了解，删除该项目</wf-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import sysApi from "@/services/api/systemSetting/systemSetting.js"
import projectApi from '@/services/api/project/project'
import productApi from '@/services/api/product/product'
import ColorControl from '@/components/colorControl'
export default {
  props: {
    dataset: {
      type: Object,
      default: () => { }
    },
    editVisible: {
      type: Boolean,
      default: false
    },
    // 窗口为项目详情
    projectDetailVisible: {
      type: Boolean,
      default: true
    }
  },
  components: {
    ColorControl
  },
  data() {
    return {
      projectName: '',
      loading: false,
      projectFoderList: [],
      options: [],
      fromData: {
        title: '',
        content: '',
        project_list_id: null,
        default_view: '1',
        product_ids: []
      },
      props: {
        // lazy: true,
        multiple: true,
        emitPath: false,
        // lazyLoad: this.lazyLoad
      }
    }
  },
  watch: {
    editVisible: {
      async handler(val) {
        if (val) {
          this.fromData = JSON.parse(JSON.stringify(this.dataset))
          this.fromData.default_view = this.fromData.default_view.toString()
          this.fromData.product_ids = this.dataset.project_products ? this.dataset.project_products.map(res => res.id) : []
          await this.lazyLoad({level: 0})
          this.dataset.project_products.forEach(res => {
            let obj = { level: 1, data: this.options.find(temp => temp.value === res.product_series_id) }
            this.lazyLoad(obj)
          })
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapState('project/project', {
      isCeartor: state => state.isCeartor
    })
  },
  created() {
    this.fetchProjectFolderList();
  },
  methods: {
    ...mapActions('project/project', ['editProject', 'getProjectFolderlist', 'deleteproject', 'archiveProject']),
    // fetchProjectFolderList() {
    //   this.getProjectFolderlist().then(res=>{
    //     this.projectFoderList = res
    //   })
    // },
    productChange(val) {
      let id = val[0]
      let obj = { level: 1, data: this.options.find(res => res.value === id) }
      this.lazyLoad(obj)
    },
    async lazyLoad(node) {
      const { level, data } = node
      if (level === 0) {
        if(this.options.length > 0) return
        let result = await productApi.productSeriesIndex({ page: 1, per_page: 999, development_status: [10, 30] })
        let treeNodes = result?.data.map(res => {
          return {
            value: res.id,
            label: res.series_name,
            children: []
          }
        })
        this.options = JSON.parse(JSON.stringify(treeNodes))
        return
      } else if (level === 1 && data.children.length === 0) {
        let result = await productApi.productsIndex({ product_series_id: data.value, page: 1, per_page: 999, development_status: [10, 30] })
        let treeNodes = result?.data.map(res => {
          return {
            value: res.id,
            label: res.product_name,
            disabled: res.development_status === 40,
            leaf: true,
            lazy: false
          }
        })
        this.options.find(res => {
          if (res.value === data.value) {
            res.children = JSON.parse(JSON.stringify(treeNodes))
            return true
          }
        })
      }
      console.log('--------dd--------', this.options)
    },
    fetchProjectFolderList() {
      sysApi.getDepartmentProjectFolderList().then(res => {
        this.projectFoderList = this.filterFloderList(res);
      })
    },
    filterFloderList(data) {
      let temp = data.filter((item) => {
        return item.department_category_id === this.fromData.project_depart_id
      })
      return temp[0] && temp[0].projectList || []
    },
    save() {
      this.loading = true
      let form = {
        project_id: this.fromData.project_id,
        title: this.fromData.title + "",
        content: this.fromData.content,
        project_list_id: this.fromData.project_list_id,
        default_view: this.fromData.default_view,
        product_ids: this.fromData.product_ids,
        ...this.colorDataset
      }
      this.editProject(form).then(res => {
        this.loading = false
        this.$emit('projectSuccess')
      }).catch(err => {
        this.loading = false
      })
    },
    async delProject() {
      await this.$wfAlert('warning', '删除项目', '删除项目后，所有内容将被抹去，请谨慎操作是否继续?')
      this.deleteproject({
        project_id: this.fromData.project_id,
      }).then(res => {
        this.loading = false
        this.$emit('delSuccess');
      }).catch(err => {
        this.loading = false
      })
    },
    async arcProject() {
      await this.$wfAlert('warning', `归档项目`, '项目归档后,将不会出现在工作台中,可以重新激活将项目恢复正常, 是否继续?')
      this.archiveProject({
        project_id: this.fromData.project_id,
      }).then(res => {
        this.loading = false
        this.$emit('delSuccess', true);
      }).catch(err => {
        this.loading = false
      })
    },
    async frozenProject() {
      await this.$wfAlert('warning', `冻结项目`, '冻结该项目后，将暂停项目内的所有编辑功能。你可以重新激活将项目恢复正常。是否继续?')
      this.editProject({
        project_id: this.fromData.project_id,
        status: -2
      }).then(res => {
        this.loading = false
        this.$emit('delSuccess', true);
      }).catch(err => {
        this.loading = false
      })
    },
    handleClick(tab) {
      console.log(this.fromData, tab)
    },
    async colorChange(val) {
      let {project_id, background_color, background_text} = val
      await projectApi.updateProjectBackground({project_id,background_color ,background_text})
      this.$emit('getProjectDetail')
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/mixin.scss";
.project-setting-drawer {
  .el-drawer__header {
    height: 54px;
    line-height: 54px;
    margin-bottom: 20px;
    padding: 0 24px;
    box-sizing: border-box;
    @include fontColorOpacity(1);
  }
  .el-drawer__body {
    padding: 0 24px;
  }
}
.edit-view {
  padding-bottom: 20px;
  .el-form-item__label {
    padding: 0;
    line-height: 20px;
    margin-bottom: 8px;
  }
  .el-textarea__inner {
    width: 432px;
    height: 199px;
    border-radius: 4px;
    border: 1px solid rgba(32,32,32,0.16);
  }
  .el-select, .el-cascader {
    width: 100%;
  }
  .el-radio-group {
    width: 100%;
    display: flex;
    margin-top: 14px;
    .el-radio-button {
      flex: 1;
      .el-radio-button__inner {
        width: 100%;
        padding: 9px 15px;
      }
    }
  }
  .edit-title {
    font-size: 16px;
    line-height: 20px;
    margin: 32px 0 8px;
    font-weight: 600;
  }
  .color-red {
    color: #f56c6c;
  }
  .edit-conten {
    font-size: 14px;
    line-height: 20px;
    color: initial;
    opacity: 0.4;
  }
  .edit-btn {
    margin-top: 16px;
    .el-button {
      width: 242px;
      height: 32px;
    }
  }
  .my-form {
    .el-form-item .el-input__prefix .color-control .el-dropdown .el-dropdown-link img {
      width: 20px;
      height: 20px;
      border-radius: 4px;
    }
    .el-form-item .has-color .el-input__inner {
      padding-left: 70px;
    }
    .el-form-item .color-control {
      border-right: 1px solid rgba(32, 32, 32, 0.16);
      // padding-right: 8px;
      height: 100%;
      .el-dropdown {
        display: flex;
        align-items: center;
        height: 100%;
      }
      .icon {
        margin-right: 8px;
      }
    }
    .el-form-item .el-input__prefix {
      left: 8px;
    }
  }
}
</style>
